import https from "@/lib/https";
import type {
  ProfileSkillDetail,
  ProfileSkillPayload,
  ProfileSkillBulkPayload,
  GetProfileSkillListParams,
} from "@/interface/profile";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/user-skills/";

export const getProfileSkillList = async (
  params?: GetProfileSkillListParams,
): Promise<
  ApiResponse<PaginationResponse<ProfileSkillDetail> | ProfileSkillDetail[]>
> => {
  return await https.get<
    ApiResponse<PaginationResponse<ProfileSkillDetail> | ProfileSkillDetail[]>
  >(BASE_URL, params);
};

export const getProfileSkillById = async (
  id: number | string,
): Promise<ApiResponse<ProfileSkillDetail>> => {
  return await https.get<ApiResponse<ProfileSkillDetail>>(`${BASE_URL}${id}/`);
};

export const createProfileSkill = async (
  payload: ProfileSkillBulkPayload,
): Promise<ApiResponse<ProfileSkillDetail[]>> => {
  return await https.post<ApiResponse<ProfileSkillDetail[]>>(BASE_URL, payload);
};

export const updateProfileSkill = async (
  payload: ProfileSkillBulkPayload,
): Promise<ApiResponse<ProfileSkillDetail[]>> => {
  return await https.put<ApiResponse<ProfileSkillDetail[]>>(BASE_URL, payload);
};

export const patchProfileSkill = async (
  id: number | string,
  payload: Partial<ProfileSkillPayload>,
): Promise<ApiResponse<ProfileSkillDetail>> => {
  return await https.patch<ApiResponse<ProfileSkillDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteProfileSkill = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};

export const deleteProfileSkillCategory = async (
  categoryId: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(
    `/api/user-skills/category/${categoryId}/`,
  );
};
